import { jsx as a, Fragment as l } from "react/jsx-runtime";
import { cn as u } from "../../../lib/utils.mjs";
import { PaginationLinkVariants as w } from "./PaginationLinkVariants.mjs";
import { useLocation as U, Link as $ } from "react-router-dom";
const y = ({
  className: i,
  variant: c = "default",
  size: f = "default",
  disabled: n = !1,
  children: s,
  isActive: o = !1,
  url: P,
  paginationParam: g = "page",
  page: h,
  as: p = "link",
  ...m
}) => {
  const d = U(), S = (e, r, t) => {
    const L = new URL(e, typeof window < "u" ? window.location.origin : "/");
    return L.searchParams.set(r, t), L.toString();
  }, k = (e, r) => {
    const t = new URLSearchParams(d.search);
    return r === "1" ? (t.delete(e), `${d.pathname}?${t.toString()}`) : (t.set(e, r), `${d.pathname}?${t.toString()}`);
  };
  return /* @__PURE__ */ a(l, { children: o ? /* @__PURE__ */ a(
    "span",
    {
      className: u(
        w({
          variant: c,
          size: f,
          disabled: n,
          active: o
        }),
        i
      ),
      "aria-disabled": n,
      ...m,
      children: s
    }
  ) : p === "a" ? /* @__PURE__ */ a(l, { children: /* @__PURE__ */ a(
    "a",
    {
      className: u(
        w({
          variant: c,
          size: f,
          disabled: n,
          active: o
        }),
        i
      ),
      href: S(P || (typeof window < "u" ? window.location.href : "/"), g, h.toString()),
      "aria-disabled": n,
      ...m,
      children: s
    }
  ) }) : /* @__PURE__ */ a(l, { children: /* @__PURE__ */ a(
    $,
    {
      className: u(
        w({
          variant: c,
          size: f,
          disabled: n,
          active: o
        }),
        i
      ),
      to: k(g, h.toString()),
      "aria-disabled": n,
      ...m,
      children: s
    }
  ) }) });
};
y.displayName = "PaginationLink";
export {
  y as default
};
//# sourceMappingURL=PaginationLink.mjs.map
